module.exports = __webpack_public_path__ + "static/geecon-79047ac3f9e150445e6786e58eacb616.png";